import { get } from '../helpers/generator';

const generateCssFromHtml = async (html) => {
  const generator = get();
  return generator.generateCssFromHtml(html);
};

export default generateCssFromHtml;
